import React, { useState, useEffect } from "react";
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import {API_URL} from "../utils/api";
import { ToastContainer, toast } from 'react-toastify';

const ContentListLayer = () => {
    const [posts, setPosts] = useState([]);

    const [ischanged, setIschanged] = useState(false);

    useEffect(() => {
        // Fetch data
        axios.get(process.env.REACT_APP_API_BASE_URL+"pagecontent-list")
            .then(response => {
                setPosts(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [ischanged]);

    useEffect(() => {
        // Initialize DataTable after posts are rendered
        if (posts.length > 0) {
            const table = $('#dataTable').DataTable({
                pageLength: 10,
            });

            // Cleanup function
            return () => {
                
            };
        }
    }, []); // Re-run this effect when posts change
    const formatDate = (dateString) => {
        return format(new Date(dateString), 'dd-MM-yyyy');
    };
    const deleteContent = async(id) => {
        if(window.confirm("Are you sure want to delete this page content?")){

        axios.get(process.env.REACT_APP_API_BASE_URL+"pagecontent-delete/"+id).then(async res => {
            toast.success('Page content deleted sucessfully!!');
            setIschanged(!ischanged);
        }).catch(err => {
            console.log(err);
        });
    }
    }
    return (
            <div className="card basic-data-table">
                <div className="card-header">
                    <h5 className="card-title mb-0"></h5>
                </div>
                <ToastContainer></ToastContainer>
                <div className="card-body">
                    <table
                        className="table bordered-table mb-0"
                        id="dataTable"
                        data-page-length={10}
                    >
                        <thead>
                            <tr>
                                <th scope="col">
                                    <div className="form-check style-check d-flex align-items-center">
                                        <label className="form-check-label">S.L</label>
                                    </div>
                                </th>
                                <th scope="col">page</th>
                                <th scope="col">title</th>
                                <th scope="col">Issued Date</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {posts.map((post,i) => (
                           
                            <tr>
                                <td>
                                    <div className="form-check style-check d-flex align-items-center">
                                        <label className="form-check-label">{i+1}</label>
                                    </div>
                                </td>
                                <td>
                                {post.page}
                                </td>
                                <td>
                                
                                {post.title}
                              
                                </td>
                                <td key={post.id}>{formatDate(post.createdAt)}</td>
                                <td>
                                    <Link
                                        to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/view-content/${post.id}`}
                                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                    >
                                        <Icon icon="iconamoon:eye-light" />
                                    </Link> <Link
                                        to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/edit-content/${post.id}`}
                                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                    >
                                        <Icon icon="lucide:edit" />
                                    </Link>

                                    <Link
                                        onClick={() => deleteContent(post.id)}
                                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                    >
                                        <Icon icon="mingcute:delete-2-line" />
                                    </Link>
                                </td>
                            </tr>
                             ))}
                        </tbody>
                    </table>
                </div>
            </div>
    )
}

export default ContentListLayer